export default function PRACompletedAssessmentController(
  $q,
  $rootScope,
  alerts,
  praDataService,
  confirmDialog,
  loaderService,
  ssDialogService,
  userService,
  praSharedModelService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;
  vm.loaderService = loaderService;
  vm.canExpand = false;
  vm.handleUnapprove = _handleUnapprove;
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.users = praSharedModelService.users;
    const dfdActivate = $q.defer();

    _initPermissions();
    dfdActivate.resolve();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('policyRiskAssessment').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  // Unapprove Assessment

  function _handleUnapprove($event) {
    ssDialogService.dialogs.pra.unapproveCompletedAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unapprove Assessment?',
        message: `Are you sure you want to Unapprove Assessment "${vm.assessment.name}"? This will make the Assessment
         active again."`,
        handleYesClick: _handleConfirmUnapprove,
        handleNoClick: _handleCancelUnapprove,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pra.unapproveCompletedAssessmentConfirmDialog);
  }

  function _handleConfirmUnapprove() {
    loaderService.showViewLoader = true;
    return praDataService.unapproveAssessment(vm.assessment.assessmentId).then(() => {
      alerts.success('The Assessment has been unapproved successfully.');
      $rootScope.$broadcast('refreshPRAAssessments');
      _closeUnapproveDialog();
    }).catch(() => {
      alerts.error('An error occurred unapproving the Assessment.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelUnapprove() {
    _closeUnapproveDialog();
  }

  function _closeUnapproveDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.unapproveCompletedAssessmentConfirmDialog);
  }

  // Delete Assessment

  function _handleDelete($event) {
    ssDialogService.dialogs.pra.deleteCompletedAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Assessment?',
        message: `Are you sure you want to delete assessment "${vm.assessment.name}"?"`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pra.deleteCompletedAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return praDataService.deleteAssessment(vm.assessment.assessmentId)
      .then(() => {
        alerts.success('The assessment has been deleted successfully.');
        $rootScope.$broadcast('refreshPRAAssessments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred deleting the assessment.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.deleteCompletedAssessmentConfirmDialog);
  }
}

PRACompletedAssessmentController.$inject = [
  '$q',
  '$rootScope',
  'alerts',
  'praDataService',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'userService',
  'praSharedModelService'
];
